import React from "react";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";

const Landing = ({ projects }) => {
  return (
    <section className="scroll-section-special py-secondary lg:py-primary lg:-mt-[42vh] xsl:-mt-[46vh] xxl:-mt-[52vh]">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10   relative">
          {[...projects]?.map((project) => (
            <Link
              // key={index}
              to={`/projects/${project.slug}`}
              className="h-[350px] lg:h-[450px] w-full relative overflow-hidden group shadow-2xl shadow-[#ffffff34]"
            >
              <img
                src={project.image}
                alt=""
                className="w-full h-full transition ease-in duration-500 group-hover:scale-[1.05]"
              />
              <p className="absolute left-4 text-3xl font-bold bottom-4 z-[10]  text-white">
                {project.title}
              </p>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Landing;
